import instance from "../../../axiosConfig/index";

export async function login(data) {
  return await instance.post("/auth/admin-login", data);
}
export async function logout(data) {
  return;
}
